export enum NavigationButtonDirection {
	PREV = 'prev',
	NEXT = 'next',
}

export enum NavigationButtonSize {
	SMALL = 'small',
	MEDIUM = 'medium',
	LARGE = 'large',
}
